import { Link } from "react-router-dom";
import { Handshake, Users, HeartHandshake, ArrowRight } from "lucide-react";

export default function GetInTouch() {
  const cards = [
    {
      id: "membership",
      href: "/membership",
      icon: HeartHandshake,
      kicker: "For supporters",
      title: "Become a member",
      body: "Join a community of like-minded people building better schools across Africa. One-time fee — pay what you can afford.",
      cta: "Open the membership form",
      testid: "touch-membership-card",
    },
    {
      id: "volunteer",
      href: "/volunteer",
      icon: Users,
      kicker: "For individuals",
      title: "Volunteer with us",
      body: "Teach, build, photograph, mentor — bring whatever skill you have. We will match you to a project that needs you.",
      cta: "Open the volunteer form",
      testid: "touch-volunteer-card",
    },
    {
      id: "partner",
      href: "/partner",
      icon: Handshake,
      kicker: "For organisations",
      title: "Partner with us",
      body: "Schools, NGOs, corporates, media, government — let’s build something together. Tell us about your organisation and we will reach out within a week.",
      cta: "Open the partnership form",
      testid: "touch-partner-card",
    },
  ];

  return (
    <section data-testid="touch-section" id="contact" className="bg-[var(--bone)] py-24 md:py-32">
      <div className="container-x">
        <div className="grid grid-cols-12 gap-6 items-end mb-14">
          <div className="col-span-12 md:col-span-8">
            <div className="overline text-[var(--terracotta)]">Get in touch</div>
            <h2 className="font-serif text-4xl md:text-5xl mt-4 tracking-[-0.02em] leading-[1.05]">
              Three ways to start a conversation.
            </h2>
          </div>
          <p className="col-span-12 md:col-span-4 text-sm text-[var(--ink)]/70">
            We read every message ourselves. We will respond within a week.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {cards.map((c) => {
            const Icon = c.icon;
            return (
              <Link
                key={c.id}
                to={c.href}
                data-testid={c.testid}
                className="group block bg-[var(--bone-2)] border border-black/10 p-8 md:p-10 hover:bg-[var(--forest)] hover:text-[var(--bone)] hover:border-[var(--forest)] transition-colors duration-300"
              >
                <div className="flex items-center justify-between">
                  <Icon className="w-10 h-10 text-[var(--terracotta)]" strokeWidth={1.5} />
                  <span className="overline text-[var(--muted)] group-hover:text-[var(--bone)]/60">
                    {c.kicker}
                  </span>
                </div>
                <h3 className="font-serif text-3xl md:text-4xl mt-8 tracking-[-0.02em] leading-tight">
                  {c.title}
                </h3>
                <p className="mt-4 leading-relaxed text-[var(--ink)]/75 group-hover:text-[var(--bone)]/75">
                  {c.body}
                </p>
                <div className="mt-8 inline-flex items-center gap-2 text-sm font-medium border-b border-[var(--ink)] group-hover:border-[var(--terracotta)] group-hover:text-[var(--terracotta)] pb-1">
                  {c.cta} <ArrowRight className="w-4 h-4" />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
